import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { Apollo } from 'apollo-angular';

import { GET_CLEARING_UNIVERSITIES, GET_UNIVERSITIES } from './queries.graphql';
import { ClearingUniversitiesResponse } from '@uc/web/shared/data-models';
import {
	UniversitiesResponse,
	UniversitySearchPayload,
} from '../models/university-search.models';

@Injectable({
	providedIn: 'root',
})
export class UniversitiesApiService {
	constructor(private _apollo: Apollo) {}

	// GraphQL
	getUniversities(args: UniversitySearchPayload) {
		return this._apollo
			.query<UniversitiesResponse>({
				query: GET_UNIVERSITIES,
				variables: {
					product: args.product,
					name: args.name,
					limit: args.limit,
					locationIds: args.locationIds,
					page: +args.page,
					offset: args.offset,
				},
			})
			.pipe(map(({ data }) => data.universities));
	}

	getClearingUniversities(args: UniversitySearchPayload) {
		return this._apollo
			.query<ClearingUniversitiesResponse>({
				query: GET_CLEARING_UNIVERSITIES,
				variables: {
					name: args.name,
					limit: args.limit,
					locationIds: args.locationIds,
					page: +args.page,
					fromStart: args.fromStart,
				},
			})
			.pipe(map(({ data }) => data.clearingUniversities));
	}
}
